<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/F7Ooxy/CoverDesign.jpg?1685327561005" alt="This image is the cover for the book Parting Shot, A Matter of Time Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Parting Shot, A Matter of Time Series
      </h1>
      <p class="bookDescription body article font2">
        <p><b><i>A Matter of Time Story</i></b></p><p>Life has never been easy for Duncan Stiel. His childhood was the stuff of nightmares, and his day job as an undercover police officer forces him to hide his true self and occasionally lands him in the hospital. So when he finally meets the perfect man, it comes as no surprise that everything falls apart around him. What Duncan doesn’t expect is that the hardest hurdle to get over before he can make a life with Aaron Sutter is the one inside himself.</p> <p>Everyone thinks Aaron has it all—looks, money, fame, and success beyond measure. Everyone, that is, except Aaron. At the end of the day, the cameras stop flashing, friends go back to their own lives, company business is handled, and Aaron is always alone. The moment he meets Duncan Stiel, Aaron knows he’ll do anything to hold onto the larger-than-life detective. But when he realizes money won’t buy him the ultimate happiness, Aaron needs to find the strength to give Duncan something much more important—his heart.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mary Calmes
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Dreamspinner Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4a7c908a